// extracted by mini-css-extract-plugin
export default {"innerWrapper":"yu-z","tooltipWrapper":"zu-z","icon":"Au-z","tooltip":"Bu-z","content":"Cu-z"};